import { ParsePromotionalBadges } from "@auer-steel/Handlers/Utilities";
import { getProductReplacementProductsWithResult } from "@auer-steel/Services/ProductReplacementProductService";
import { getProductPromotionsWithResult } from "@auer-steel/Services/PromotionService";
import { addToChainAfter, addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { chain, DispatchCompleteLoadProduct } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProduct";

export type HandlerType = Parameters<typeof DispatchCompleteLoadProduct>[0];

addToChainBefore(chain, DispatchCompleteLoadProduct, ParsePromotionalBadgeData);

addToChainBefore(chain, DispatchCompleteLoadProduct, GetAvailablePromotions);

addToChainBefore(chain, DispatchCompleteLoadProduct, GetReplacementProductData);

function ParsePromotionalBadgeData(props: HandlerType) {
    // AST-166
    if (props.apiResult) {
        ParsePromotionalBadges(props.apiResult);
    }
}

async function GetReplacementProductData(props: HandlerType) {
    // if (props.apiResult.isDiscontinued) {
    const replacementProductInformation = await getProductReplacementProductsWithResult(props.apiResult.id);
    props.apiResult.replacementProductNumber = replacementProductInformation;
    // }
}

async function GetAvailablePromotions(props: HandlerType) {
    // AST-43
    if (props.apiResult) {
        const promotions = await getProductPromotionsWithResult(props.apiResult.id);
        props.apiResult.promotions = promotions.promotions;
    }
}
